module.exports = __webpack_public_path__ + "static/media/24-6.a6ddac2f.mp3";